import { useRouter } from 'next/router';
import { RelatedAdsCard } from '../../../../../components/PageWrappers/AdDetails/components/RelatedAds/components/RelatedAdsCard/RelatedAdsCard';

import type { RelatedAdsProps } from '../../../../../components/PageWrappers/AdDetails/components/RelatedAds/RelatedAds.typed';

import * as Styled from '../../../../../components/PageWrappers/AdDetails/components/RelatedAds/RelatedAds.styled';

import convertToFriendlyPath from '../../../../../utils/FriendlyPath';
import { accessibleOnClick } from '../../../../../utils/Accessibility';

import { VIEW_TYPE } from '../../../../../components/ToolkitV2/CardV2/Card.typed';

const RelatedAds = (props: RelatedAdsProps) => {
  const { domain, relatedAds, viewType, testId } = props;

  const router = useRouter();

  return (
    <Styled.List viewType={viewType} data-testid={testId}>
      {relatedAds?.map((ad) => {
        const friendlyPath = convertToFriendlyPath(domain, ad.friendlyUrl!);

        return (
          <Styled.CardListItem
            key={ad.id}
            {...accessibleOnClick(() => router.push(friendlyPath), 'link')}
          >
            <RelatedAdsCard item={ad} isGrid={viewType === VIEW_TYPE.GRID} />
          </Styled.CardListItem>
        );
      })}
    </Styled.List>
  );
};

export { RelatedAds };
